import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionInterface } from 'app/core/auth/models/permission.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionsRepositoryService {
  constructor(private readonly _http: HttpClient) {}

  getPermissions(): Observable<PermissionInterface[]> {
    return this._http.get<PermissionInterface[]>(`auth/init/permissions`);
  }
}
